export default {
  id: 9,
  pride: 31744,
  slug: "fleet-battle",
  category: "game",
  status: "archived",
  experienceable: false,
  titleKey: {
    zh: "舰队激斗",
    en: "Fleet Battle"
  },
  image: require('@/assets/images/fb.webp'),
  descriptionKey: {
    zh: "一款召唤战舰对战的弹幕互动游戏。赚了4k和五个舰长。目前不可玩。",
    en: "A bullet comment interactive game featuring battleship summoning combat. Earned 4k and five captains. Currently not playable."
  },
  date: { year: 2022, month: 4 },
  genres: ["弹幕互动", "策略", "对战"],
  themes: ["太空"],
  engine: "虚幻引擎 4.26",
  platform: ["PC"],
  achievements: [
    { zh: "直播收入流水总共 6k", en: "Total stream revenue 6k RMB" },
    { zh: "七个人上舰", en: "Seven stream captains" },
    { zh: "带来 50 多个粉丝群群友", en: "Brought 50+ members to the fan group" }
  ],
  developerNotesKey: {
    zh: "战舰召唤弹幕互动战斗游戏，直播收入流水总共6k，七个人上舰。带来了大量玩家，以及50多个粉丝群群友，大家每日讨论游戏机制。弹幕互动品类降温后下架。当时品类红利期，头部弹幕互动游戏日流水可达3万，不少低完成度作品也能获得可观收入。本作是一次随品类热度的变现尝试，也带来了流量和大量玩家。品类冷却后，转向毕业设计、AI相关开发与网页开发。",
    en: "Battleship summoning interactive game. Brought in many players and 50+ fan group members who discussed mechanics daily. Taken down after the genre cooled off. During the genre boom, top titles could earn tens of thousands RMB per day, and even low-polish works saw strong revenue. This was an attempt to monetize during that window, which brought traffic and players. After the genre cooled, I moved on to my graduation project, AI development, and web dev."
  },
  tags: ["弹幕互动"],
  longDescriptionKey: {
    zh: "",
    en: ""
  },
  links: [
    { type: "bilibili", url: "https://www.bilibili.com/video/BV1k34y1e7Ew/", textKey: { zh: "六道激光一穿五", en: "Six Lasers, One Shot Through Five" } },
    { type: "bilibili", url: "https://www.bilibili.com/video/BV123411P7kz/", textKey: { zh: "v4 冲撞与烟花录播", en: "v4 Clash & Fireworks Recording" } },
    { type: "bilibili", url: "https://www.bilibili.com/video/BV1A54y1Z7rb/", textKey: { zh: "500个不崩优化实录", en: "Optimized from 20 to 500 Without Crash" } },
    { type: "bilibili", url: "https://www.bilibili.com/video/BV1tt4y1x7Vi/", textKey: { zh: "v6.4 连崩两次实录", en: "v6.4 Double Crash Recording" } }
  ]
};
